/*
Componente botón para aceptación de cookies

CORREGIDO para Safari (Node 16.20.2, React 16.12.0):
- Reemplaza @material-ui/core/Fab + SettingsIcon por un <button> HTML nativo
- Evita la inyeccion asincrona de JSS de Material-UI que causa race condition
  en Safari (boton aparece sin event handlers brevemente)
- Elimina la dependencia de @material-ui/icons (lazy load)
- Usa estilos inline + clases CSS para maxima compatibilidad Safari
*/

import React from 'react'
import './CookieConsent.css'

export default function CookieButton({ onClick, show = true }) {
  if (!show) {
    return null
  }

  return (
    <button
      type='button'
      className='cookie-sticky-btn'
      onClick={onClick}
      data-lang-attr='title'
      data-lang-title='cookie_button_tooltip'
      aria-label='Configurar cookies'
      title='Configurar cookies'
    >
      {/* SVG inline del icono de settings (sin dependencia @material-ui/icons) */}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden='true'
        focusable='false'
      >
        <circle cx='12' cy='12' r='3'></circle>
        <path d='M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z'></path>
      </svg>
    </button>
  )
}
